var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightingServiceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#8FB16A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1654 79.1666H55.832M38.332 58.7499H61.6654M29.582 41.2499C29.582 35.8351 31.7331 30.642 35.5619 26.8132C39.3908 22.9843 44.5839 20.8333 49.9987 20.8333C55.4135 20.8333 60.6066 22.9843 64.4355 26.8132C68.2643 30.642 70.4154 35.8351 70.4154 41.2499C70.4173 44.5372 69.6222 47.776 68.0983 50.6887C66.5744 53.6014 64.367 56.1013 61.6654 57.9741L60.0845 65.4582C59.8752 66.8377 59.1784 68.0965 58.1205 69.0062C57.0625 69.916 55.7136 70.4163 54.3183 70.4166H45.6791C44.2838 70.4163 42.9349 69.916 41.8769 69.0062C40.819 68.0965 40.1222 66.8377 39.9129 65.4582L38.332 58.0062C35.6295 56.1267 33.422 53.621 31.8983 50.7031C30.3746 47.7852 29.5799 44.5417 29.582 41.2499Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingServiceActive);
export default __webpack_public_path__ + "static/media/LightingServiceActive.d2b1886edfd3b9712f6667a0f6e6d400.svg";
export { ForwardRef as ReactComponent };